import type {ViewStoreModel} from "@stores/ViewStore";


export const getRedirectUrlAndRemoveItFromSearchParams = (viewStore: ViewStoreModel) => {
    let redirectURL = viewStore.query.redirectTo;
    const clearedQuery = {...viewStore.query};
    delete clearedQuery.redirectTo;

    viewStore.setQuery(clearedQuery);

    let url = `${import.meta.env.VITE_BASE_PATH}/workspace`;
    if (redirectURL) {
        if (redirectURL.indexOf('http') !== 0) {
            redirectURL = `${import.meta.env.VITE_BASE_PATH}/${redirectURL.slice(1)}`;
        }
        url = redirectURL;
    }

    return url;
}